<template>
  <ElDialog
    class="download-invoice-factor-modal"
    width="500px"
    :visible="value"
    :title="$t('ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_INVOICE_FACTOR')"
    :close-on-click-modal="false"
    @close="close"
  >
    <div class="download-invoice-factor-modal__body">
      <img
        class="download-invoice-factor-modal__image"
        src="~@/assets/images/invoice-factor-image.svg"
      />
      <div class="download-invoice-factor-modal__email-notice">
        {{ $t('ADVERTISEMENT.TRANSACTIONS.EMAIL_NOTICE') }}
      </div>
      <div>
        {{ $t('ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_FACTOR_BODY') }}
      </div>
    </div>
    <span slot="footer" class="row align-center">
      <ElButton
        :loading="isLoading"
        type="primary"
        icon="el-icon-download"
        @click="downloadInvoiceFactor"
      >
        {{ $t('ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_INVOICE_FACTOR') }}
      </ElButton>
    </span>
  </ElDialog>
</template>

<script>
import FileSaver from 'file-saver';
import { AdFinance } from '@/api/api';

export default {
  name: 'DownloadInvoiceFactorModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    invoiceId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    downloadInvoiceFactor() {
      this.isLoading = true;
      return AdFinance.downloadInvoiceFactor(this.invoiceId)
        .then(blob => {
          FileSaver.saveAs(
            blob,
            `cafebazaar-advertisement-factor-${this.invoiceId}.pdf`,
          );

          this.$message.success(
            this.$t('ADVERTISEMENT.TRANSACTIONS.DOWNLOAD_FACTOR_SUCCESSFUL'),
          );

          this.close();
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.download-invoice-factor-modal {
  &__body {
    text-align: center;
  }

  &__image {
    width: rem-calc(60px);
    margin-bottom: $global-margin;
  }

  &__email-notice {
    font-weight: bold;
    margin-bottom: $global-margin;
  }
}
</style>
